import { dbRef } from "../../db-ref";
import { ResourceSubPipeline } from "../../utils";
import { getUserSnippetPipeline } from "../users";
import { zServiceProjectTask } from "./service-project-task-resource";
import { getTaskPipelines } from "../tasks/task-pipelines";

const taskServiceProjectPipeline: ResourceSubPipeline = {
  mainStages: [
    {
      $lookup: {
        from: dbRef.serviceProject.collection,
        localField: "linkedId",
        foreignField: "_id",
        as: "serviceProjectDoc",
      },
    },
    { $unwind: "$serviceProjectDoc" },
  ],
  projectStage: {
    "serviceProjectDoc._id": 1,
    "serviceProjectDoc.serviceId": 1,
    "serviceProjectDoc.serviceDetails.title": 1,
  },
};
``;
export function getServiceProjectTaskPipelines() {
  const taskPipelines = getTaskPipelines();
  const clientDocPipeline = getUserSnippetPipeline(
    "serviceProjectDoc.clientId",
    "serviceProjectDoc.clientDoc",
  );

  return {
    _z: zServiceProjectTask,
    mainStages: [
      ...taskPipelines.mainStages,
      ...taskServiceProjectPipeline.mainStages,
      ...clientDocPipeline.mainStages,
    ],
    projectStage: {
      ...taskPipelines.projectStage,
      ...taskServiceProjectPipeline.projectStage,
      ...clientDocPipeline.projectStage,
    },
  };
}
